module.exports = __webpack_public_path__ + "media/country_flags/re-1c4dc352.png";